import { render } from "./Colors.vue?vue&type=template&id=4b62ed3a"
import script from "./Colors.vue?vue&type=script&lang=js"
export * from "./Colors.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__